module.exports = __webpack_public_path__ + "img/testimonial3.6b594973.jpeg";